import { createContext, useCallback, useContext, useEffect, useState } from "react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(false);
  const [authModal, setAuthModal] = useState(null); // null | "signin" | "signup"

  useEffect(() => {
    const token = localStorage.getItem("fp_token");
    if (!token) {
      setReady(true);
      return;
    }
    fetch(`${API}/auth/me`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => (r.ok ? r.json() : Promise.reject(new Error("expired"))))
      .then((u) => setUser(u))
      .catch(() => localStorage.removeItem("fp_token"))
      .finally(() => setReady(true));
  }, []);

  const applyAuth = (d) => {
    localStorage.setItem("fp_token", d.token);
    setUser(d.user);
  };

  const signOut = () => {
    localStorage.removeItem("fp_token");
    setUser(null);
  };

  const authFetch = useCallback(
    (path, opts = {}) => {
      const token = localStorage.getItem("fp_token");
      const headers = { ...(opts.headers || {}) };
      if (token) headers.Authorization = `Bearer ${token}`;
      return fetch(`${API}${path}`, { ...opts, headers });
    },
    []
  );

  return (
    <AuthContext.Provider value={{ user, ready, applyAuth, signOut, authFetch, authModal, setAuthModal }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
